/** Device profiles the preview can render at.
 *
 *  412x892 @ DPR 3 is the default: Pixel 6/7/8 class, and `412 * 2.625 ~= 360 * 3 = 1080`,
 *  the most common widthPixels in the Android fleet — so the resize CDN is already warm
 *  for `inside_1080`. Spec §7.
 */
import type { DeviceProfile } from './types';

export const DEVICE_PROFILES: DeviceProfile[] = [
  {
    id: 'android-phone',
    label: 'Android phone (412dp)',
    platform: 'android',
    formFactor: 'phone',
    widthDp: 412,
    heightDp: 892,
    density: 3,
    imageWidthPx: 1080,
    statusBarDp: 24,
    navBarDp: 0,
  },
  {
    id: 'android-phone-360',
    label: 'Android phone (360dp)',
    platform: 'android',
    formFactor: 'phone',
    widthDp: 360,
    heightDp: 800,
    density: 3,
    imageWidthPx: 1080,
    statusBarDp: 24,
    navBarDp: 0,
  },
];

export const DEFAULT_DEVICE_ID = 'android-phone';

export function deviceById(id: string): DeviceProfile {
  return DEVICE_PROFILES.find((d) => d.id === id) ?? DEVICE_PROFILES[0]!;
}

/** What the app passes to the resize service (spec §6.1, §7).
 *
 *  NOT `widthDp * density`. Spec §7 is explicit: `inside_<w>` is **1080**, hard-coded,
 *  because that is the most common `widthPixels` in the Android fleet and so the only
 *  size the resize CDN is reliably warm for. The listed DPR of 3.0 exists to pick asset
 *  buckets — a real Pixel is 2.625, and `412 × 2.625 ≈ 360 × 3 = 1080`. Deriving it
 *  instead produced `inside_1236`: a size no device ever requests, so every preview
 *  image was a cache miss AND not the bytes the app actually receives. */
export function imageWidthPx(device: DeviceProfile): number {
  return device.imageWidthPx;
}
